import React from 'react';
import { ClassAssembly4A2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly4A2026 />;
  };
  
  export default ClassAssemblyPage;